import * as React               from "react";
import * as variableDataHandler from "./tools/variable-data-handler";


export const getMergeFieldErrorMessage = async ({apis, ccEditor, templateOptions}) => {

    let mergeFieldErrors = await variableDataHandler.getInvalidMergeFieldsFromEditor(
        await apis.next.templateAdmin.getVariableDataMergeFields(),
        ccEditor
    );

    // remove errors missing braces around common words
    const ignoreCommonWords = ["firstname", "lastname", "address", "city", "state", "zipcode"];
    mergeFieldErrors = mergeFieldErrors.filter(x => !ignoreCommonWords.includes(x.tag));

    // prepare message for error fields
    if (mergeFieldErrors.length) {

        // return message tailored to a single tag missing braces
        return (mergeFieldErrors.length === 1
            && mergeFieldErrors[0].tag.indexOf("{") < 0
            && mergeFieldErrors[0].tag.indexOf("}") < 0) ? <>
                Your <i>{mergeFieldErrors[0].fieldName}</i> content references{" "}
                <code>{mergeFieldErrors[0].tag}</code>, which is a known merge field that
                is missing surrounding braces. If you meant for this to use the recipient data, it should be
                formatted as <code>{"{{"}{mergeFieldErrors[0].tag}{"}}"}</code>. If not changed, this will be
                displayed as-is without a replacement value.
                <br/><br/>
                Please correct this merge field to ensure accurate personalization.
            </>

            // return message tailored to a single unknown tag
            : (mergeFieldErrors.length === 1) ? <>
                    Your <i>{mergeFieldErrors[0].fieldName}</i> content references{" "}
                    <code>{mergeFieldErrors[0].tag}</code>, which is an unknown merge field.
                    This will appear as-is in your final print, meaning the recipient data will not be filled in.
                    <br/><br/>
                    Please correct this merge field to ensure accurate personalization.
                </>

                // return list of errors if multiple issues
                : <>
                    Your content references unknown merge fields. These will appear as-is in your final print, meaning
                    the recipient data will not be filled in:
                    <br/>
                    <ul>
                        {mergeFieldErrors.map(x => <li key={x.tag}>
                            <code>{x.tag}</code> in <i>{x.fieldName}</i> content.
                        </li>)}
                    </ul>
                    Please correct these merge fields to ensure accurate personalization.
                </>;

    }

    // prepare message for merge fields on subsequent pages
    if (templateOptions.numSurfacesPerPage && ccEditor.surfaces) {

        const usedMergeFields = await variableDataHandler.getUsedMergeFields(
            await apis.next.templateAdmin.getVariableDataMergeFields(),
            ccEditor
        );

        let validSurfaces = [];
        for (let i = 0; i < templateOptions.numSurfacesPerPage; i++) {
            validSurfaces.push(ccEditor.surfaces[i]?.name);
        }

        if (usedMergeFields.find(x => !validSurfaces.includes(x.surfaceName))) {
            return <>Merge fields can only be used on the first page. Any merge fields on subsequent pages will be displayed as-is without replacement values.</>;
        }

    }

    return null;
};